<template>
  <div class="ask_wrapper">
    <header id="askheader_top">
      <section class="head_back" @click="$router.go(-1)" v-show="appversion == 'new'">
        <img src="~assets/images/back-btn.png" alt />
        <span>{{headTitle}}</span>
      </section>
      <div slot="ask-title" class="ask_title">
        <button class="title_text" :disabled="published" @click="publish()">发布</button>
      </div>
    </header>
     <div class="name_title">{{liveName}}</div>
    <div class="text_area">
     
      <textarea v-model="message" cols="30" rows="10" placeholder="提问不能少于5个字"></textarea>
    </div>
    <div class="question_list">
      <div class="title">试试这样问</div>
      <div class="list">
        <span
          v-for="item in questions"
          :key="item.id"
          @click="transferQ(item.content)"
        >{{item.content}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from "assets/commonjs/toast";
import { getStore } from "assets/commonjs/storage";
import user from "assets/commonjs/userInfo";
export default {
  data() {
    return {
      headTitle: "提问",
      message: [],
      account: "",
      id: "",
      liveName: "",
      displayName: "",
      appversion: "new",
      published: false,
      pushMessage: false,
      questions: [
        {
          content: "黄金现在该如何布局?",
          id: 1
        },
        {
          content: "美油最近是啥趋势?",
          id: 2
        },
        {
          content: "外汇近期哪个好做?",
          id: 3
        },
        {
          content: "现在推荐啥好做的?",
          id: 4
        }
      ]
    };
  },
  created() {
       if(getStore('liveappver') != "" && getStore('liveappver') != undefined && getStore('liveappver') != null){
          //肯定是新版
          this.appversion = "new" 
      }else if(getStore('noneheader') == null  
      || getStore('noneheader') == ""  
      || getStore('noneheader') == undefined){
            //移动端
         this.appversion = 'new'
      }else{
         this.appversion = "old" 
       }
  },
  components: {},
  mounted() {
    this.published = false;
    this.id = this.$route.query.id;
    this.liveName = this.$route.query.liveName;
    this.account = JSON.parse(getStore("userInfoAll")).account;
    this.displayName = JSON.parse(getStore("userInfoAll")).displayName;
    if (!this.account) {
      this.$router.push("/login");
    }
  },
  methods: {
    transferQ(content) {
      this.pushMessage = true
      this.message.push(content);
    },
    publish() {
      if (
        getStore("userInfoAll") == null ||
        getStore("userInfoAll") == "" ||
        getStore("userInfoAll") == undefined
      ) {
        if (
          getStore("noneheader") == null ||
          getStore("noneheader") == "" ||
          getStore("noneheader") == undefined
        ) {
          this.$router.push("/login");
        } else {
          // app拦截登录
          window.location.href = "intercept_login";
        }
      } else {
        if(!this.pushMessage){
          if (this.message == "") {
          toast("内容不能为空");
        } else if (this.message.length > 80) {
          toast("内容不能超过80个字");
        } else if (this.message.length < 5) {
          toast("内容不能少于5个字");
        } else {
          let data = {
            account: this.account,
            question: this.message,
            companyId: 1,
            topicId: this.id,
            displayName: this.displayName
          };
          this.upData(data)
          
        }
        }else{
          let message = this.message.join(',')
          let data = {
            account: this.account,
            question: message,
            companyId: 1,
            topicId: this.id,
            displayName: this.displayName
          };
           this.upData(data)
        }
        
      }
    },
    upData(data){
      this.published = true;
          this.$api.strageList.publish(data).then(res => {
            
            if (res.data && res.data.code == 0) {
              toast("老师或客服会尽快回复您的提问");

              setTimeout(() => {
                // this.$router.push(`/questionDetail/:${this.id}`);
                this.$router.push({ path: 'questionDetail',query:{id:this.id,label:'askBack'} })
                this.published = false;
              }, 1000);
            } else {
              this.published = false;
            }
          });
          this.pushMessage = false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
#askheader_top {
  @include wh(100%, 0.9rem);
  position: relative;
  background: #fff;
  border-bottom: 0.025rem solid #ddd;
  .head_back {
    @include wh(auto, 0.9rem);
    padding-top: 0.1rem;
    line-height: 0.9rem;
    margin-left: 0.3rem;
    font-size: 0;
    text-align: left;
    float: left;
    img {
      @include wh(0.44rem, 0.44rem);
      position: relative;
      top: 0.1rem;
    }
    span {
      @include center;
      font-size: 0.32rem;
      font-weight: bold;
    }
  }
}
.ask_wrapper {
  // position: fixed;
  // width: 100%;
  // height: 100%;
  // top: 0px;
  background: #f0f1f5;
}
.text_area {
  padding: 0.5rem 0.3rem 0;
  textarea {
    @include sc(0.3rem, #333);
    background: #f0f1f5;
    width: 100%;
  }
}
.ask_title {
  font-size: 0;
  position: absolute;
  right: 0.32rem;
  top: 0.2rem;
  .title_text {
    @include sc(0.28rem, #999);
    background: #fff;
  }
}
.question_list {
  background: #f0f1f5;
  text-align: left;
  padding-left: 0.3rem;
  padding-bottom: 0.3rem;
  .title {
    @include sc(0.28rem, #666);
    margin-bottom: 0.3rem;
  }
  .list {
    font-size: 0;
    span {
      background: #fff;
      border-radius: 0.06rem;
      display: inline-block;
      margin-right: 0.2rem;
      margin-bottom: 0.1rem;
      @include sc(0.24rem, #0a95ff);
      text-align: center;
      padding: 0.08rem 0.2rem;
    }
  }
}
.name_title{
  @include sc(.32rem,#333);
  font-weight: bold;
  padding:.25rem;
  background: #fff;
}
</style>